import React, { useEffect, useState } from "react";
import CpntDataTable from "../../components/dataTable/CpntDataTable";
//import CpntFacette from "../../components/CpntFacette";
import { getDefaultFilterCompte } from "../../models/interfaces/IFilterCompte";
import { ITitle } from "../../models/interfaces/ITitle";
import { ICompteList } from "../../models/interfaces/ICompte";
import { ICompteListExport } from "../../models/interfaces/ICompte";

import { ISorter } from "../../models/interfaces/ISorter";
import { ILocation } from "../../models/interfaces/ILocation";
import { useKeycloak } from "@react-keycloak/web";
import { Link } from "react-router-dom";
import CpntPagination from "../../components/CpntPagination";
import { useFetchBOComptesQuery, useLazyFetchBOComptesToExportQuery } from "../../redux/slice/api/BO/compteApi";
import ComptesBOFilter from "./Utilisateurs/ComptesBOFilter";
import { dtoToFilter, filterToQuery, IFilterCompteBO, IFilterCompteBODTO } from "../../models/interfaces/IFilterCompteBO";
import SpinnerEditeurPro from "../FO/components/SpinnerEditeurPro";
import HtmlRenderActifToStatus from "../../components/HtmlRender/HtmlRenderActifToStatus";

const PageUtilisateurs: React.FC = () => {
  // const { idsociete } = useParams();
  // const IdSociete = idsociete ?? "";
  const [listfilter, setListFilter] = useState<IFilterCompteBO>();
  const [searchParams, setSearchParams] = useState<IFilterCompteBODTO|undefined>(undefined);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  //const [facettes, setFacettes] = useState<IFacetteFiltre[]>([]); // |null
  const [isDescending, setIsDescending] = useState<boolean>();
  const [sortField, setSortField] = useState("");

  //const [initiateDownload, setInitiateDownload] = useState(false)
  //const [csvDataToDownload, setCsvDataToDownload] = useState(null)

  //const [editeur, setediteur] = useState(""); // État local pour stocker la valeur de l'entrée


//  applyFilter
// useEffect(() => {
//   IdSociete && applyFilter({Id:parseInt(IdSociete)})
// }, [IdSociete])


  useEffect(() => {

    localStorage.removeItem("activeTab");

    const storedFilter = localStorage.getItem("IFilterComptes");
    const storedSorter = localStorage.getItem("ISortStore");

    if (storedFilter !== null && storedFilter !== undefined) { // && storedSorter !== null && storedSorter !== undefined) {
      setListFilter(JSON.parse(storedFilter));
    } else {
      setListFilter(getDefaultFilterCompte());
    }

    if (storedSorter !== null && storedSorter !== undefined) {
      const currSorter:ISorter = JSON.parse(storedSorter);
      currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
      currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    }

  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterCompte()) {
      const _filter: IFilterCompteBODTO = filterToQuery({
        ...listfilter,
        //...IdSociete && {Id:parseInt(IdSociete)},
        ...(sortField && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 0 && { Limit: limit }),
        ...(offset >= 0 && limit >= 0 && { Offset: offset})
      });
      setSearchParams(_filter);
      localStorage.setItem("IFilterComptes",JSON.stringify(_filter));
    }
  }, [listfilter, sortField, isDescending, offset, limit]);

  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const { data: ComptesResult, isFetching, error } = useFetchBOComptesQuery(searchParams, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParams === null || searchParams === undefined || listfilter === undefined || (searchParams.Limit ?? 0) < 10,
  });

  const [triggerExport, { isFetching: isExporting }] = useLazyFetchBOComptesToExportQuery();

  const handleExport = async () => {
    const result = await triggerExport(searchParams);
    if (result.error) {
      return;
    }
    const comptes: ICompteListExport[] = result?.data?.Comptes ?? [];
    if (!comptes.length) {
      return;
    }
    const headers = Object.keys(comptes[0]) as (keyof ICompteListExport)[];
    const escapeCell = (val: unknown): string => {
      const str = val === null || val === undefined ? "" : Array.isArray(val) ? val.join(", ") : String(val);
      return '"' + str.replace(/"/g, '""') + '"';
    };
    const csvContent = [
      headers.join(";"),
      ...comptes.map((row) => headers.map((h) => escapeCell(row[h])).join(";"))
    ].join("\n");
    const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "comptes_export_" + new Date().toISOString().slice(0, 10) + ".csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };




  const applyFilter = (data: IFilterCompteBO) => {
    //data.FacettesFiltre = [];
    setListFilter(data);
    setOffset(0);
    setLimit(10);
  }

  const actions: ILocation[] = [
    {
      PathsName: { Voir: "/admin/utilisateurmodifbo/[[Id]]" },
      State: { type_access: "" },
      ClassName: "bi-receipt Action-button",
    },
  ];

  const dataHeaderName: ITitle[] = [
    {
      Id: "Id",
      Name: "Id",
      Class: "",
      sorter: (a: ICompteList, b: ICompteList) =>
        a.Id - b?.Id,
    },
    {
      Id: "Actif",
      Name: "Statut",
      Class: "",
      sorter: (a: ICompteList, b: ICompteList) =>
        (a?.Actif === b?.Actif) ? 1 : a?.Actif ? 0 : -1,
    },
    {
      Id: "Nom",
      Name: "Nom",
      Class: "",
      sorter: (a: ICompteList, b: ICompteList) =>
        a?.Nom?.localeCompare(b?.Nom),
    },
    {
      Id: "Prenom",
      Name: "Prénom",
      Class: "",
      sorter: (a: ICompteList, b: ICompteList) =>
        a?.Prenom?.localeCompare(b?.Prenom),
    },
    {
      Id: "Email",
      Name: "Email",
      Class: "",
      sorter: (a: ICompteList, b: ICompteList) =>
        a?.Prenom?.localeCompare(b?.Prenom),
    },
    {
      Id: "DateCreation",
      Name: "Date de Création",
      Class: "desktop-only-section",
      sorter: (a: ICompteList, b: ICompteList) =>
        (a.DateCreation || "").localeCompare(b.DateCreation || "", "fr"),
    },
    {
      Id: "DateModification",
      Name: "Date de Modification",
      Class: "desktop-only-section",
      sorter: (a: ICompteList, b: ICompteList) =>
        (a.DateModification || "").localeCompare(b.DateModification || "", "fr"),
    },
    {
          Id: "NbMarques",
          Name: "Nombre de marques",
          Class: ""

    },
  ];

    //  const changeFacette = (filtre: IFacetteFiltre,checked: boolean ) => {
    //   // setSearchParams(
    //   //   filterToQuery({
    //   //     ...listfilter,
    //   //     FacettesFiltre: checked
    //   //     ? [...(searchParams?.FacettesFiltre ?? []), filtre]
    //   //     : searchParams?.FacettesFiltre?.filter(fac => fac.filtreName !== filtre.filtreName || fac.filtreValue !== filtre.filtreValue)
    //   //   })
    //   // );
    //   setListFilter(
    //     filterToQuery({
    //       ...listfilter,
    //       FacettesFiltre: checked
    //       ? [...(searchParams?.FacettesFiltre ?? []), filtre]
    //       : searchParams?.FacettesFiltre?.filter(fac => fac.filtreName !== filtre.filtreName || fac.filtreValue !== filtre.filtreValue)
    //     })
    //   );
    // }

  const dataItemsStyle = {
    Id: "",
    Actif: <HtmlRenderActifToStatus />,
    Nom: "",
    Prenom: "",
    DateCreation: "",
    DateModification: "",
    Email:"",
    NbMarques:"",
  };

return (
  <div className="container text-center">
      <div className="row pt-3 pb-2">
        <div className="col col-12 ">
          <h2 className="titreModule titre-bleu"><i className="bi-people pe-2" />Gestion des utilisateurs</h2>
        </div>
      </div>
      <div className="row pt-3 pb-5">
        <div className="col-12 ">
        <div className="row card mb-2 mt-2">
          {searchParams && (
            <>
              <ComptesBOFilter
                filter={dtoToFilter(searchParams)}
                changeFilter={applyFilter}
              />
              {/* {NoticesResult?.Facettes &&
                <CpntFacette FacettesSelected={searchParams?.FacettesFiltre} Facettes={NoticesResult?.Facettes} onChange={(filtre,checked) => changeFacette(filtre,checked)} />
              }    */}
            </>
          )}

        </div>
        <div className="row ">
          {ComptesResult?.Quantite !== null && ComptesResult?.Comptes &&
            <div className="col-auto pb-3 pt-3">
              Nb de résultats :<b>&nbsp;{ComptesResult.Quantite}&nbsp;</b>

            </div>
          }
          {isFetching ? (
            <SpinnerEditeurPro />
          ) : error ? (
            <div>Error</div>
          ) : (
            <>
            <div className="d-flex justify-content-start gap-2">
                <Link to={`/admin/nouvelutilisateurbo`} className="btn btn-secondary">Déclarer un nouvel utilisateur</Link>
                <button className="btn btn-outline-success" onClick={handleExport} disabled={isExporting}>
                  {isExporting ? <><span className="spinner-border spinner-border-sm me-1" />Export en cours...</> : <><i className="bi bi-download me-1" />Exporter CSV</>}
                </button>
                </div>
            {ComptesResult?.Comptes && ComptesResult?.Quantite !== null && ComptesResult.Quantite > 0 &&
              <>
                <CpntPagination limit={limit} offset={offset} numberOfResults={ComptesResult.Quantite} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={ComptesResult && ComptesResult.Comptes ? [...ComptesResult.Comptes] : []}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    actualFilterPage="PageUtilisateurs"
                    updateSorter={setSortField}
                    updateDescending={setIsDescending}
                />
                </div>
              </div>
              <CpntPagination limit={limit} offset={offset} numberOfResults={ComptesResult.Quantite} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>
              </>}
              </>
          )}
        </div>
        </div>
      </div>
    </div>
  );
};

export default PageUtilisateurs;
